import MetricsCard from "@/components/vendor/dashboard/MetricsCard";
import RecentOrders from "@/components/vendor/dashboard/RecentOrders";
import PerformanceMetrics from "@/components/vendor/dashboard/PerformanceMetrics";
import QuickActions from "@/components/vendor/dashboard/QuickActions";
import WelcomeSection from "@/components/vendor/dashboard/WelcomeSection";
import SalesCharts from "@/components/vendor/dashboard/SalesCharts";
import { DollarSign, Package, ShoppingBag, Users } from "lucide-react";

const VendorDashboard = () => {
  return (
    <div className="space-y-8">
      <WelcomeSection />
      
      {/* Key Metrics Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <MetricsCard
          icon={DollarSign}
          iconColor="text-white"
          iconBgColor="bg-gradient-to-br from-[#9b87f5] to-[#8B5CF6]"
          title="Today's Sales"
          value="$12,426"
          trend={{ value: "+12.5%", isPositive: true }}
        />

        <MetricsCard
          icon={Package}
          iconColor="text-white"
          iconBgColor="bg-gradient-to-br from-green-400 to-green-600"
          title="Active Products"
          value="124"
          subtitle="12 new this month"
        />

        <MetricsCard
          icon={ShoppingBag}
          iconColor="text-white"
          iconBgColor="bg-gradient-to-br from-[#F97316] to-orange-600"
          title="Pending Orders"
          value="18"
          subtitle="8 need attention"
        />

        <MetricsCard
          icon={Users}
          iconColor="text-white"
          iconBgColor="bg-gradient-to-br from-[#7E69AB] to-purple-700"
          title="Total Customers"
          value="2,845"
          trend={{ value: "+18% this month", isPositive: true }}
        />
      </div>

      {/* Quick Actions */}
      <QuickActions />

      {/* Charts */}
      <SalesCharts />

      {/* Recent Activity & Performance Metrics */}
      <div className="grid md:grid-cols-2 gap-6">
        <RecentOrders />
        <PerformanceMetrics />
      </div>
    </div>
  );
};

export default VendorDashboard;